




















import Vue, { PropOptions } from 'vue';
interface Props {
  active: PropOptions;
  showEdit: PropOptions;
}
export default Vue.extend({
  name: 'ProductSummaryItem',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
  } as Props,
});
